
import { useState } from "react";
import { HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { 
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

export const RecipeTransformationGuide = () => {
  const [isGuideOpen, setIsGuideOpen] = useState(false);
  
  return (
    <div className="flex justify-center">
      <Collapsible 
        open={isGuideOpen} 
        onOpenChange={setIsGuideOpen}
        className="w-full max-w-md border border-primary/20 rounded-lg overflow-hidden shadow-sm"
      >
        <div className="bg-primary/10 px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <HelpCircle className="h-4 w-4 text-primary" />
            <span className="text-sm font-medium">How to use this tool</span>
          </div>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
              <span className="sr-only">Toggle guide</span>
              {isGuideOpen ? 
                <span className="text-xs">Hide</span> : 
                <span className="text-xs">Show</span>
              }
            </Button>
          </CollapsibleTrigger>
        </div>
        <CollapsibleContent className="p-5 text-sm space-y-4 bg-primary/5">
          <div className="space-y-3">
            <h3 className="font-medium text-primary">How to copy & paste a recipe URL:</h3>
            <ol className="list-decimal list-inside space-y-2 text-gray-700">
              <li>Find a recipe you like on any cooking website</li>
              <li>Click in the address bar at the top of your browser</li>
              <li>Copy the entire URL (press Ctrl+C or Command+C)</li>
              <li>Paste the URL into the input box below (press Ctrl+V or Command+V)</li>
              <li>Click the "Make it Kid-Friendly!" button</li>
            </ol>
          </div>
          <p className="text-xs text-gray-500 italic">
            Works with most popular recipe websites like AllRecipes, Food Network, Epicurious, and more!
          </p>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};
